import * as React from "react";
import { ComponentServices } from "../ComponentServices";
// Move to common/kalep-integration
export var useTimezoneOffset = function useTimezoneOffset(props) {
  var _React$useContext = React.useContext(ComponentServices.Context),
    timezoneService = _React$useContext.timezoneService;
  return React.useMemo(function () {
    var _a, _b;
    var offset = timezoneService.getTimezoneOffset((_a = props === null || props === void 0 ? void 0 : props.timezone) !== null && _a !== void 0 ? _a : "UTC", (_b = props === null || props === void 0 ? void 0 : props.unix) !== null && _b !== void 0 ? _b : undefined);
    var hours = Math.floor(offset / 60);
    var minutes = offset - hours * 60;
    var sign = hours <= 0 ? "+" : "-";
    return "UTC".concat(sign).concat(hours < 10 ? "0" : "").concat(Math.abs(hours), ":").concat(minutes < 10 ? "0" : "").concat(minutes);
  }, [props === null || props === void 0 ? void 0 : props.timezone, props === null || props === void 0 ? void 0 : props.unix, timezoneService]);
};